import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'GET_ONLINE_ANALYSIS',
    manual: false
  });
  useEffect(() => {
    if (params) {
      let url = `/api/online/status/analysis`;
      const param_ = JSON.parse(params)
      Object.keys(param_).forEach((key, index) => {
        if (index === 0) {
          url += '?'
        } else {
          url += '&'
        }
        url += `${key}=${param_[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || [], exec, isRequestSuccessed];
});
